/* eslint-disable prefer-rest-params, no-restricted-globals, no-param-reassign, prefer-const */

const utils = {};

const longDayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const shortDayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const months =
  ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];

/**
 * Format a string
 *
 * Examples:
 *
 * format('{0} world!', 'Hello') => 'Hello world!'
 * format('{0} {1}!', 'Hello', 'world') => 'Hello world!'
 * format('{1} {0}!', 'world', 'Hello') => 'Hello world!'
 * format('{0} {0}, {1}!', 'Hello', 'world') => 'Hello Hello, world!'
 *
 * @param {String} Template The string template
 * @param {...String} Replacement A variable to format
 * @return {String}
 */
utils.format = function format(str) {
  const args = [].slice.call(arguments, 1);
  for (let i = 0, len = arguments.length; i < len; i++) {
    str = str.replace(new RegExp(`\\{${i}\\}`, 'gm'), args[i]);
  }
  return str;
};

/**
 * String.prototype.trim polyfill
 *
 * @param {String} str The string to trim()
 * @return {String} The trimmed string
 */
utils.trim = function trim(str) {
  if (str.trim) return str.trim();
  return str.replace(/^\s+|\s+$/g, '');
};

/**
 * Format a 1-2 digit number to a two digit string
 * example: 1 -> '01', 31 -> '31'
 * @param number
 * @returns {string}
 */
utils.zeroPad = function zeroPad(number) {
  return ((number >= 0 && number < 10) ? '0' : '') + number;
};

/**
 * Converts time to 12hour format
 * @param hours number
 * @param minutes number
 * @returns {string} Time in 12hour format, eg '1pm', '1.30pm'
 */
utils.to12HourFormat = function to12HourFormat(hours, minutes) {
  return (hours % 12 || 12) +
    (minutes ? `.${utils.zeroPad(minutes)}` : '') +
    (hours >= 12 ? 'pm' : 'am');
};

/**
 * Converts date to DD.MM.YYYY format
 * @param date Date
 * @returns {string}
 */
utils.toDotFormat = function toDotFormat(date) {
  return [date.getDate(), date.getMonth() + 1, date.getYear() - 100].map(utils.zeroPad).join('.');
};

utils.getResponsivityLevel = function getResponsivityLevel() {
  // https://stackoverflow.com/questions/4629969/ios-return-bad-value-for-window-innerheight-width
  const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  // The window.innerWidth is the actual width
  // of the window, including scrollbars, but not including the window border.
  const pageWidth = (iOS) ? screen.width : window.innerWidth || $('body').outerWidth(); // eslint-disable-line no-undef
  let level = 'desktop-wide';

  if (pageWidth <= 599) {
    level = 'mobile';
  } else if (pageWidth <= 1024) {
    level = 'tablet';
  } else if (pageWidth <= 1239) {
    level = 'desktop';
  }

  return level;
};

// Detect mobile operating system
utils.mobileOSDetection = function mobileOSDetection() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  let os = 'other';

  if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i) || userAgent.match(/iPod/i)) {
    os = 'ios';
  }
  if (userAgent.match(/Android/i)) {
    os = 'android';
  }
  if (userAgent.match(/IEMobile/i)) {
    os = 'windows-phone';
  }

  return os;
};

// Detect if device is Android or iOS
utils.isAndroidOrIOS = function isAndroidOrIOS() {
  const os = utils.mobileOSDetection();
  return os === 'android' || os === 'ios';
};

utils.isMSEdge = function isMSEdge() {
  return navigator.userAgent.indexOf('Edge') > -1;
};

utils.isStringJson = function isStringJson(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

/**
 * Returns true if possibleParent contains or is equal to possibleChild, false otherwise
 * @param possibleParent Element
 * @param possibleChild Element
 * @returns {boolean}
 */
utils.containsElement = function containsElement(possibleParent, possibleChild) {
  if (!possibleChild || !possibleParent) {
    return false;
  }
  if (possibleParent === possibleChild) {
    return true;
  }
  return containsElement(possibleParent, possibleChild.parentNode);
};

/**
 * load callback when DOM is loaded
 * @param callback
 */
utils.onDOMLoaded = function onDOMLoaded(callback) {
  if (document.readyState !== 'loading') {
    callback();
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      callback();
    }, false);
  }
};

/**
 * Returns width and height of the viewport
 *
 * @returns {{width, height}} object containing the viewport
 */
utils.viewport = function viewport() {
  let e = window;
  let a = 'inner';

  if (!('innerWidth' in window)) {
    a = 'client';
    e = document.documentElement || document.body;
  }
  return { width: e[`${a}Width`], height: e[`${a}Height`] };
};

utils.getUKTimeInSeconds = function getUKTimeInSeconds(currentDate) {
  const clientDate = currentDate || new Date();
  const clientTimeInSeconds = parseInt(clientDate.getTime() / 1000, 10);
  const serverTimezoneOffsetInSeconds = ((window.DCG && window.DCG.serverTimezoneOffset) || 0) * 60;

  return clientTimeInSeconds - serverTimezoneOffsetInSeconds;
};

function getDate(currentDate, dayOffset) {
  const date = currentDate ? new Date(currentDate.getTime()) : new Date();
  date.setDate(date.getDate() + dayOffset);
  return date;
}

function formatDate(currentDate, dayOffset, long) {
  let date;
  let weekday;
  let day;
  let month;

  long = long || false;
  date = getDate(currentDate, dayOffset);
  weekday = (long ? longDayNames : shortDayNames)[date.getDay()];
  day = date.getDate();
  month = months[date.getMonth()];
  return `${weekday} ${day} ${month}`;
}

utils.longDate = function longDate(currentDate, dayOffset) {
  return formatDate(currentDate, dayOffset, true);
};

utils.shortDate = function shortDate(currentDate, dayOffset) {
  return formatDate(currentDate, dayOffset, false);
};

utils.formatTime = function formatTime(minutesFromStartOfDay) {
  const hours = utils.zeroPad(Math.floor(minutesFromStartOfDay / 60));
  const minutes = utils.zeroPad(minutesFromStartOfDay % 60);
  return `${hours}:${minutes}`;
};

utils.debounce = function debounce(func, wait, immediate) {
  let timeout;

  return function debouncedFunction() {
    const context = this;
    const args = arguments;
    const callNow = immediate && !timeout;

    function later() {
      timeout = null;
      if (!immediate) {
        func.apply(context, args);
      }
    }

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) {
      func.apply(context, args);
    }
  };
};

utils.promiseWithTimeout = function promiseWithTimeout(promise, timeoutMs) {
  const timeoutPromise = new Promise((resolve, reject) => {
    const id = setTimeout(() => {
      clearTimeout(id);
      reject(new Error('Connection timed out'));
    }, timeoutMs);
  });

  return Promise.race([
    promise,
    timeoutPromise
  ]);
};

export default utils;

export const {
  format,
  trim,
  zeroPad,
  to12HourFormat,
  toDotFormat,
  getResponsivityLevel,
  mobileOSDetection,
  isAndroidOrIOS,
  isMSEdge,
  isStringJson,
  containsElement,
  onDOMLoaded,
  viewport,
  getUKTimeInSeconds,
  longDate,
  shortDate,
  formatTime,
  debounce,
  promiseWithTimeout
} = utils;
